import { paths } from 'ogp/paths';
import { mapOgpSidebarItems, withSectionChildren } from './ogp-sidebar-section-helpers';
import { OgpSidebarItems } from './ogp-sidebar-items.types';

export const filterManagementWorkflowsSidebarItems = (
  sidebarItems: OgpSidebarItems,
  {
    impersonatedByHq,
    allowWorkflows,
  }: {
    impersonatedByHq: boolean;
    allowWorkflows: boolean;
  }
): OgpSidebarItems => {
  if (impersonatedByHq && allowWorkflows) {
    return sidebarItems;
  }

  return mapOgpSidebarItems(sidebarItems, (section) =>
    section.key === 'management'
      ? withSectionChildren(
          section,
          section.children.filter((child) => child.path !== paths.Workflows.path)
        )
      : section
  );
};
